import { useI18n } from '../i18n';
import { Reveal } from './Reveal';
import { useAuth } from '../lib/auth';
import arbant from '../assets/partners/arbant.png';
import becaferretti from '../assets/partners/becaferretti.png';
import birraincapriasca from '../assets/partners/birraincapriasca.png';
import bvm from '../assets/partners/bvm.png';
import chalcio from '../assets/partners/chalcio.png';
import chivisin from '../assets/partners/chivisin.png';
import fin from '../assets/partners/fin.png';
import laMolesta from '../assets/partners/la-molesta.png';
import matasci from '../assets/partners/matasci.jpg';
import momoq from '../assets/partners/momoq.png';
import monteBre from '../assets/partners/monte-bre.png';
import morobiotta from '../assets/partners/morobiotta.png';
import weltu from '../assets/partners/weltu.png';

type PartnerType = 'brewery' | 'winery' | 'media' | 'event' | 'partner';

type Partner = { src: string; alt: string; name: string; type: PartnerType; url: string };

const PARTNERS: Partner[] = [
  { src: matasci, alt: 'Matasci Vini', name: 'Matasci Vini', type: 'winery', url: 'https://matasci-vini.ch' },
  { src: bvm, alt: 'BVM', name: 'BVM', type: 'brewery', url: 'https://ciao.beer' },
  { src: weltu, alt: 'Weltu', name: 'Weltu', type: 'brewery', url: 'https://www.weltu.ch' },
  { src: momoq, alt: 'MóMò', name: 'MóMò', type: 'brewery', url: 'https://www.momo.beer' },
  { src: birraincapriasca, alt: 'Birra in Capriasca', name: 'Birra in Capriasca', type: 'event', url: 'https://www.birraincapriasca.ch' },
  { src: morobiotta, alt: 'Moro Biotta', name: 'Moro Biotta', type: 'brewery', url: 'https://www.lamorobbiotta.ch' },
  { src: laMolesta, alt: 'La Molesta', name: 'La Molesta', type: 'brewery', url: 'https://lamolesta.ch' },
  { src: monteBre, alt: 'Monte Brè', name: 'Monte Brè', type: 'brewery', url: 'https://www.birramontebre.com' },
  { src: becaferretti, alt: 'Becaferretti', name: 'Becaferretti', type: 'partner', url: 'https://www.becaferretti.ch' },
  { src: arbant, alt: 'Arbant', name: 'Arbant', type: 'brewery', url: 'https://www.facebook.com/birraarbant' },
  { src: chalcio, alt: 'Chalcio.com', name: 'Chalcio.com', type: 'media', url: 'https://www.chalcio.com' },
  { src: fin, alt: 'FIN', name: 'FIN', type: 'brewery', url: 'https://www.birrificiofin.ch' },
  { src: chivisin, alt: 'Chivisin', name: 'Chivisin', type: 'brewery', url: 'https://www.chivisin.ch' },
];

export function Partners() {
  const { t, locale, localePath } = useI18n();
  const { user } = useAuth();
  // Signed-in partners/admins land straight on the dashboard; everyone
  // else gets the role-gated login page.
  const partnerHref = user?.role === 'partner' || user?.role === 'admin'
    ? localePath('/partner')
    : localePath('/partner/login');
  return (
    <section class="partners" id="partners">
      <div class="container">
        <div class="intro">
          <Reveal class="section-label" as="div">
            {t('partners.label')}
          </Reveal>
          <Reveal as="h2" class="title" delay={1} style={{ marginBottom: '1.4rem' }}>
            <em>{t('partners.title_a')}</em> {t('partners.title_b')}
          </Reveal>
          <Reveal as="p" delay={2}>
            {t('partners.body')}
          </Reveal>
        </div>

        <Reveal class="partners-grid" delay={3}>
          {PARTNERS.map((p) => (
            <a
              class="partner-card"
              key={p.name}
              href={p.url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`${p.name} — ${t(`partners.types.${p.type}`)}`}
            >
              <div class="partner-logo-wrap">
                <img class="partner-logo" src={p.src} alt={p.alt} />
              </div>
              <div class="partner-meta">
                <span class="partner-name">{p.name}</span>
                <span class="partner-type">{t(`partners.types.${p.type}`)}</span>
              </div>
            </a>
          ))}
          <div class="partner-card empty" aria-hidden="true" />
        </Reveal>

        <Reveal class="partner-cta" delay={3}>
          <div class="partner-cta-inner">
            <div class="partner-cta-copy">
              <div class="section-label on-dark">{t('partners.cta.label')}</div>
              <h3 class="partner-cta-title">
                <em>{t('partners.cta.title_a')}</em> {t('partners.cta.title_b')}
              </h3>
              <p class="partner-cta-body">{t('partners.cta.body')}</p>
            </div>
            <div class="partner-cta-actions">
              <a
                class="partner-cta-btn"
                href={`https://partnership.beercup.ch/${locale}/`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <span>{t('partners.cta.button')}</span>
                <span class="arrow" aria-hidden="true">→</span>
              </a>
              <a class="partner-existing-link" href={partnerHref}>
                {t('partners.cta.existing')}
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
